import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import PartnersPage from "./pages/PartnersPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ClientDashboard from "./pages/ClientDashboard";
import PartnerDashboard from "./pages/PartnerDashboard";
import PartnerClientDetailPage from "./pages/PartnerClientDetailPage";
import AdminDashboard from "./pages/AdminDashboard";
import ClientsPage from "./pages/ClientsPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import LettersPage from "./pages/LettersPage";
import FinancePage from "./pages/FinancePage";
import StaffSupervisionPage from "./pages/StaffSupervisionPage";
import CadastroPdfPage from "./pages/CadastroPdfPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          
          {/* Client Portal Routes */}
          <Route
            path="/client"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/profile"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/scores"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/payments"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/documents"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Partner Portal Routes */}
          <Route
            path="/partner"
            element={
              <ProtectedRoute allowedRoles={["partner"]}>
                <PartnerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/clients"
            element={
              <ProtectedRoute allowedRoles={["partner"]}>
                <PartnerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/clients/:clientId"
            element={
              <ProtectedRoute allowedRoles={["partner"]}>
                <PartnerClientDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/progress"
            element={
              <ProtectedRoute allowedRoles={["partner"]}>
                <PartnerDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Admin/Internal Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["operator", "administrative", "aline", "office_admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/clients"
            element={
              <ProtectedRoute allowedRoles={["operator", "administrative", "aline", "office_admin"]}>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/clients/:clientId"
            element={
              <ProtectedRoute allowedRoles={["operator", "administrative", "aline", "office_admin"]}>
                <ClientDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/partners"
            element={
              <ProtectedRoute allowedRoles={["administrative", "aline", "office_admin"]}>
                <PartnersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/letters"
            element={
              <ProtectedRoute allowedRoles={["operator", "administrative", "aline", "office_admin"]}>
                <LettersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/scores"
            element={
              <ProtectedRoute allowedRoles={["operator", "administrative", "aline", "office_admin"]}>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/finance"
            element={
              <ProtectedRoute allowedRoles={["administrative", "aline"]}>
                <FinancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/staff"
            element={
              <ProtectedRoute allowedRoles={["aline"]}>
                <StaffSupervisionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/cadastro-pdf"
            element={
              <ProtectedRoute allowedRoles={["aline", "office_admin"]}>
                <CadastroPdfPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute allowedRoles={["administrative", "aline", "office_admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
